import { useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';

import { AuthContext } from '../state/Context';

const useClearState = () => {
  const queryClient = useQueryClient();
  const { setTokens } = useContext(AuthContext);

  return () => {
    queryClient.clear();
    setTokens({});
  };
};

export default useClearState;
